export const APPROVALS_EN = {
    "approvals.action.add_condition": "Add a condition",
    "approvals.action.add_step": "Add a step",
    "approvals.action.approve": "Approve",
    "approvals.action.archive": "Archive",
    "approvals.action.create": "New chain",
    "approvals.action.edit": "Edit",
    "approvals.action.edit_step": "Edit",
    "approvals.action.move_up": "Move up",
    "approvals.action.publish": "Publish",
    "approvals.action.reject": "Reject or return",
    "approvals.action.remove_condition": "Remove",
    "approvals.action.remove_step": "Remove",
    "approvals.action.resend": "Send again",
    "approvals.action.revise": "New draft",
    "approvals.action.simulate": "Try it",
    "approvals.action.withdraw": "Withdraw the request",
    "approvals.amount_basis.gross": "Gross, before VAT",
    "approvals.amount_basis.net": "Net, before VAT",
    "approvals.amount_basis.with_vat": "With VAT",
    "approvals.apply_state.applied": "Applied",
    "approvals.apply_state.failed": "Apply failed",
    "approvals.apply_state.pending": "Waiting to be applied",
    "approvals.approver_kind.role": "A role",
    "approvals.approver_kind.supplied": "Members the document names",
    "approvals.approver_kind.user": "Named members",
    "approvals.chain.monogram": "AP",
    "approvals.chain.title": "Approval chain",
    "approvals.chain_conditions.empty": "No condition: it matches every document of its type.",
    "approvals.chain_conditions.note": "All must hold. None: the chain matches every document.",
    "approvals.chain_conditions.title": "Conditions",
    "approvals.chain_problems.empty": "Nothing stops it: it can be published.",
    "approvals.chain_problems.title": "Before it is published",
    "approvals.chain_state.archived": "Archived",
    "approvals.chain_state.draft": "Draft",
    "approvals.chain_state.published": "Published",
    "approvals.chain_steps.empty": "No step yet: a chain is published with at least one.",
    "approvals.chain_steps.note": "A step needs one approval, all, or a number of them. Nobody decides their own request, or one about themselves.",
    "approvals.chain_steps.title": "Steps, in order",
    "approvals.chains.empty": "No chain yet. Without a published chain, a document of that type cannot be submitted.",
    "approvals.chains.lede": "Each document type is routed by its first published chain that matches; no match refuses the request.",
    "approvals.chains.title": "Approval chains",
    "approvals.col.amount": "Amount",
    "approvals.col.amount_basis": "Amount compared",
    "approvals.col.apply_attempts": "Times sent",
    "approvals.col.apply_error": "The module's reason",
    "approvals.col.apply_state": "Applied",
    "approvals.col.approver": "Decided by",
    "approvals.col.approver_fact": "Member fact",
    "approvals.col.approver_kind": "Who decides",
    "approvals.col.approver_role": "Role",
    "approvals.col.approver_users": "Members",
    "approvals.col.at": "When",
    "approvals.col.bulk_ok": "Decided in bulk",
    "approvals.col.can_archive": "Can be archived",
    "approvals.col.can_edit": "Can be edited",
    "approvals.col.can_move_up": "Can move up",
    "approvals.col.can_publish": "Can be published",
    "approvals.col.can_resend": "Can be sent again",
    "approvals.col.can_revise": "Can get a new draft",
    "approvals.col.can_withdraw": "Can be withdrawn",
    "approvals.col.chain": "Chain chosen",
    "approvals.col.chain_id": "Chain",
    "approvals.col.completed_at": "Approved",
    "approvals.col.decider": "Decided by",
    "approvals.col.deciders": "Deciders",
    "approvals.col.document_revision": "Document version",
    "approvals.col.due_at": "Decide by",
    "approvals.col.fact_label": "Fact",
    "approvals.col.id": "Id",
    "approvals.col.name_ar": "Chain",
    "approvals.col.name_en": "Name in English",
    "approvals.col.op": "Compared",
    "approvals.col.open_runs": "Waiting requests",
    "approvals.col.outcome": "Decision",
    "approvals.col.path": "Where",
    "approvals.col.position": "Position",
    "approvals.col.priority": "Priority",
    "approvals.col.problem": "What stops it",
    "approvals.col.published_at": "Published",
    "approvals.col.reason": "Why",
    "approvals.col.ref_label": "Document",
    "approvals.col.revision": "Version",
    "approvals.col.route": "Who decides each step",
    "approvals.col.rule": "Rule",
    "approvals.col.run_id": "Run",
    "approvals.col.run_state": "Approval",
    "approvals.col.sla_hours": "Service time (hours)",
    "approvals.col.state": "Status",
    "approvals.col.step": "Step",
    "approvals.col.step_name": "Step name",
    "approvals.col.step_of": "Step of",
    "approvals.col.steps": "Steps",
    "approvals.col.type_key": "Type key",
    "approvals.col.type_label": "Document type",
    "approvals.col.value": "Value",
    "approvals.col.version": "Version read",
    "approvals.field.approver_fact": "Named by the document as",
    "approvals.field.approver_kind": "Who decides",
    "approvals.field.approver_role": "Role",
    "approvals.field.approver_users": "Members",
    "approvals.field.fact": "Fact",
    "approvals.field.name_ar": "Name in Arabic",
    "approvals.field.name_en": "Name in English",
    "approvals.field.op": "Compared",
    "approvals.field.outcome": "Decision",
    "approvals.field.priority": "Priority",
    "approvals.field.priority.help": "The lower is tried first; required to publish.",
    "approvals.field.reason": "Why",
    "approvals.field.reason.help": "The requester reads it, and it is kept on record.",
    "approvals.field.requester_user": "Who submits it",
    "approvals.field.requester_user.help": "Left empty: you.",
    "approvals.field.sla_hours": "Service time (hours)",
    "approvals.field.sla_hours.help": "Past it, the step is announced late once a day; it escalates only when escalation is set below, and nothing is approved by itself.",
    "approvals.field.type_key": "Document type",
    "approvals.field.value": "Value",
    "approvals.field.value.help": "An amount in riyals with up to two decimals; several values separated by commas.",
    "approvals.field.value_to": "To under",
    "approvals.field.value_to.help": "Only for a range: its upper end, not included.",
    "approvals.hub.inbox.empty": "Nothing waits for your decision.",
    "approvals.hub.inbox.one": "Document",
    "approvals.hub.inbox.summary": "{summary} · {step}",
    "approvals.hub.inbox.title": "Documents",
    "approvals.not_applied.empty": "Nothing approved is waiting to be applied.",
    "approvals.not_applied.lede": "Approvals their module has not applied yet, or failed to; the fix is in the document, then send it again.",
    "approvals.not_applied.title": "Approved, not applied",
    "approvals.op.between": "from … to under",
    "approvals.op.eq": "equals",
    "approvals.op.gt": "more than",
    "approvals.op.gte": "at least",
    "approvals.op.in": "one of",
    "approvals.op.lt": "less than",
    "approvals.op.lte": "at most",
    "approvals.op.ne": "is not",
    "approvals.op.not_in": "none of",
    "approvals.outcome.approve": "Approved",
    "approvals.outcome.awaiting": "Waiting for a decision",
    "approvals.outcome.cancelled": "Withdrawn",
    "approvals.outcome.not_reached": "Not reached",
    "approvals.outcome.reject": "Rejected",
    "approvals.outcome.sent_back": "Returned",
    "approvals.outcome_choice.reject": "Reject: the request ends here",
    "approvals.outcome_choice.return": "Return for a change: the requester sends a new version",
    "approvals.refusal.about_self": "Nobody decides a request about themselves.",
    "approvals.refusal.limit": "Ask for 1 to {max} items.",
    "feed.approvals.assigned": "Approvals waiting on me",
    "feed.approvals.assigned.status.waiting": "Waiting for you",
    "feed.approvals.assigned.status.overdue": "Overdue",
    "feed.approvals.assigned.status.escalated": "Escalated",
    "feed.approvals.assigned.status.cannot_decide": "Not yours to decide now",
    "approvals.refusal.access_unavailable": "The record's own unit could not be asked who may read it. Nothing was read; try again.",
    "approvals.refusal.archived": "This chain is already archived.",
    "approvals.refusal.bulk_not_allowed": "{type} is decided one at a time.",
    "approvals.refusal.bulk_over_limit": "Above {max} it is decided one at a time.",
    "approvals.refusal.bulk_return": "A request is returned one at a time, never in bulk.",
    "approvals.refusal.condition_fact": "A condition reads one of the document type's facts.",
    "approvals.refusal.condition_op": "That fact is not compared that way.",
    "approvals.refusal.condition_value": "That is not a value this fact can hold.",
    "approvals.refusal.conditions_shape": "The conditions are a list.",
    "approvals.refusal.decided_before": "You decided an earlier step of this request; another person decides this one.",
    "approvals.refusal.draft_exists": "This chain already has a draft.",
    "approvals.refusal.fact_choice": "Choose one of its options.",
    "approvals.refusal.fact_money": "An amount with at most two decimals.",
    "approvals.refusal.fact_number": "A number.",
    "approvals.refusal.fact_party": "A party.",
    "approvals.refusal.fact_unknown": "This document type has no such fact.",
    "approvals.refusal.fact_users": "A list of members.",
    "approvals.refusal.facts_shape": "The facts are the type's declared facts.",
    "approvals.refusal.members_forbidden": "Listing the members needs permission to see users.",
    "approvals.refusal.members_unavailable": "The members could not be listed just now; try again.",
    "approvals.refusal.no_chain": "No approval chain is set up for {type} yet. Ask whoever sets up approvals.",
    "approvals.refusal.no_chain_found": "There is no such approval chain.",
    "approvals.refusal.no_permission": "You do not hold the permission this needs.",
    "approvals.refusal.no_run": "There is no such approval request.",
    "approvals.refusal.no_steps": "A chain has at least one step.",
    "approvals.refusal.no_such_condition": "There is no such condition.",
    "approvals.refusal.no_such_step": "There is no such step.",
    "approvals.refusal.not_draft": "A published or archived chain is not edited; make a new draft of it.",
    "approvals.refusal.not_from": "This request has already ended; there is nothing to decide.",
    "approvals.refusal.not_published": "Only a published chain gets a new draft.",
    "approvals.refusal.not_requester": "Only whoever made a request withdraws it.",
    "approvals.refusal.nothing_to_resend": "Only an approval its module has not applied is sent again.",
    "approvals.refusal.out_of_scope": "This step is not yours to decide.",
    "approvals.refusal.own_request": "Whoever made a request does not decide it.",
    "approvals.refusal.previous_open": "The earlier request has not ended.",
    "approvals.refusal.previous_other": "The earlier request is not this document's.",
    "approvals.refusal.priority_required": "A published chain has a priority.",
    "approvals.refusal.priority_shape": "The priority is a whole number from 1 to 999.",
    "approvals.refusal.priority_taken": "Another published chain of this type has priority {priority}.",
    "approvals.refusal.reason_long": "A reason is at most {max} characters.",
    "approvals.refusal.reason_required": "Say why: the requester reads it.",
    "approvals.refusal.ref_shape": "This is not a document's id.",
    "approvals.refusal.required": "This is required.",
    "approvals.refusal.revision_older": "A document is sent again at its version or a later one.",
    "approvals.refusal.revision_shape": "The document's version is a whole number from 1.",
    "approvals.refusal.role_lacks_permission": "Step {step}: the role {role} does not hold {permission}; add it to the role or choose another.",
    "approvals.refusal.role_no_holders": "Step {step}: nobody holds the role {role}.",
    "approvals.refusal.role_unknown": "Step {step}: there is no role {role} here.",
    "approvals.refusal.roles_forbidden": "Refreshing the roles needs permission to see users.",
    "approvals.refusal.roles_unavailable": "What each role may do could not be read just now; try again.",
    "approvals.refusal.roles_unknown": "Who holds which role is not known here yet; refresh it first.",
    "approvals.refusal.run_open": "This document is already waiting on an approval; withdraw it first.",
    "approvals.refusal.stale": "Somebody changed this since you opened it. Reload and try again.",
    "approvals.refusal.step_fact": "The members are named by one of the type's member facts.",
    "approvals.refusal.step_kind": "A step is decided by a role, named members, or members the document names.",
    "approvals.refusal.step_role": "Choose the role that decides this step.",
    "approvals.refusal.step_sla": "The service time is whole hours, 1 to 8760.",
    "approvals.refusal.step_users": "Choose one to {max} members.",
    "approvals.refusal.step_without_deciders": "Nobody but you could decide step {step}; ask whoever sets up approvals.",
    "approvals.refusal.steps_shape": "The steps are a list.",
    "approvals.refusal.subject": "There is no such record, or it is not yours to read.",
    "approvals.refusal.subject_users": "A list of members.",
    "approvals.refusal.too_long": "At most {max} characters.",
    "approvals.refusal.too_many_conditions": "At most {max} conditions.",
    "approvals.refusal.too_many_steps": "At most {max} steps.",
    "approvals.refusal.type_unknown": "No module of this workspace declares this document type.",
    "approvals.refusal.types_forbidden": "This workspace's modules could not be listed for you.",
    "approvals.refusal.types_unavailable": "The document types could not be read just now; nothing was changed.",
    "approvals.refusal.unit_token": "The request came with a unit token that could not be verified; nothing was filed.",
    "approvals.refusal.users_inactive": "Step {step}: none of the members named is an active member.",
    "approvals.refusal.version_shape": "The version is the whole number the row was read at.",
    "approvals.run_state.approved": "Approved",
    "approvals.run_state.in_progress": "Waiting for approval",
    "approvals.run_state.rejected": "Rejected",
    "approvals.run_state.returned": "Returned",
    "approvals.run_state.withdrawn": "Withdrawn",
    "approvals.simulate.no_chain": "No chain matches: the submission would be refused, never approved.",
    "approvals.simulate.nobody": "Step {step} has nobody to decide it.",
    "approvals.simulate.preview": "The route it would take",
    "approvals.simulate.roles_unknown": "Who holds which role is not known yet: refresh it first.",
    "approvals.simulate.skipped": "{chain} (priority {priority}) did not match.",
    "approvals.subject_runs.empty": "This document has not been sent for approval.",
    "approvals.subject_runs.title": "Approval path",
    "change.field.chain.approver_fact": "Named by the document as",
    "change.field.chain.approver_kind": "Who decides",
    "change.field.chain.approver_label_ar": "Decided by (Arabic)",
    "change.field.chain.approver_label_en": "Decided by (English)",
    "change.field.chain.approver_role": "Role",
    "change.field.chain.approver_users": "Members",
    "change.field.chain.archived_at": "Archived",
    "change.field.chain.archived_by": "Archived by",
    "change.field.chain.conditions": "Conditions",
    "change.field.chain.created_by": "Created by",
    "change.field.chain.lineage_id": "Chain",
    "change.field.chain.name_ar": "Name in Arabic",
    "change.field.chain.name_en": "Name in English",
    "change.field.chain.position": "Step",
    "change.field.chain.priority": "Priority",
    "change.field.chain.published_at": "Published",
    "change.field.chain.published_by": "Published by",
    "change.field.chain.revision": "Version",
    "change.field.chain.sla_hours": "Service time (hours)",
    "change.field.chain.state": "Status",
    "change.field.chain.type_key": "Document type",
    "change.field.run.activated_at": "Reached",
    "change.field.run.amount": "Amount",
    "change.field.run.applied_at": "Applied at",
    "change.field.run.apply_attempts": "Times sent",
    "change.field.run.apply_error": "The module's reason",
    "change.field.run.apply_error_key": "Reason key",
    "change.field.run.apply_sent_at": "Last sent",
    "change.field.run.apply_state": "Applied",
    "change.field.run.candidates": "Who may decide",
    "change.field.run.chain_id": "Chain",
    "change.field.run.chain_revision": "Chain version",
    "change.field.run.chain_snapshot": "Chain as frozen",
    "change.field.run.completed_at": "Ended",
    "change.field.run.completed_by": "Ended by",
    "change.field.run.correlation_id": "Correlation",
    "change.field.run.current_seq": "Current step",
    "change.field.run.decided_at": "Decided at",
    "change.field.run.decided_by": "Decided by",
    "change.field.run.document_revision": "Document version",
    "change.field.run.due_at": "Decide by",
    "change.field.run.facts": "Facts",
    "change.field.run.id": "Step",
    "change.field.run.module": "Module",
    "change.field.run.name_ar": "Step name in Arabic",
    "change.field.run.name_en": "Step name in English",
    "change.field.run.previous_run_id": "Earlier request",
    "change.field.run.ref_entity": "Record type",
    "change.field.run.ref_id": "Record",
    "change.field.run.ref_label": "Document",
    "change.field.run.requester_party": "Requester",
    "change.field.run.requester_user": "Requested by",
    "change.field.run.seq": "Step number",
    "change.field.run.state": "Status",
    "change.field.run.steps_total": "Steps",
    "change.field.run.subject_party": "About",
    "change.field.run.subject_user_ids": "About (members)",
    "change.field.run.submitted_at": "Submitted",
    "change.field.run.type_key": "Document type",
    "change.field.run.type_snapshot": "Type as frozen",
    "entity.approvals.chain": "approval chain",
    "entity.approvals.subject": "approval path",
    "hub.flag.cannot_decide": "You can no longer decide this",
    "nav.approvals.chains": "Approval chains",
    "nav.approvals.not_applied": "Approved, not applied",
    "nav.module.approvals": "Approvals",
    "value.apply_state.failed": "Apply failed",
    "value.apply_state.pending": "Waiting to be applied",
    "value.state.archived": "Archived",
    "value.state.published": "Published",
    "approvals.refusal.step_manager_level": "The manager is 1 to 5 levels up.",
    "approvals.refusal.step_fallback_role": "Choose the role that decides when no manager can.",
    "approvals.refusal.step_mode": "A step needs one approval, every decider's, or a number of them.",
    "approvals.refusal.step_required": "A quorum is 2 to 20 approvals.",
    "approvals.refusal.quorum_unreachable": "Step {step} needs {required} approvals, and only {deciders} could give them.",
    "approvals.refusal.step_escalate_hours": "Escalation waits whole hours, 1 to 8760.",
    "approvals.refusal.step_escalate_kind": "A step escalates to a role, named members, or a manager.",
    "approvals.refusal.step_escalate_role": "Choose the role the step escalates to.",
    "approvals.refusal.step_escalate_users": "Choose one to 20 members to escalate to.",
    "approvals.refusal.every_step_skippable": "Every step could be skipped. Leave at least one step that is never skipped, so a document is never approved by nobody.",
    "approvals.refusal.every_step_skipped": "Every step of the chain would be skipped for this document; it is never approved by nobody. Ask whoever sets up approvals.",
    "approvals.refusal.system_chain": "This chain ships with its module and is read only. Publish a chain of your own to route these documents differently.",
    "approvals.refusal.already_approved": "You approved this step already; it waits on the others.",
    "approvals.simulate.quorum_unreachable": "Step {step} needs {needed} approvals and has fewer deciders.",
    "approvals.simulate.step_skipped": "Step {step} is skipped for these facts.",
    "approvals.col.origin": "Made by",
    "approvals.chain_origin.system": "Its module (read only)",
    "approvals.chain_origin.workspace": "This workspace",
    "approvals.approver_kind.manager": "The requester's manager",
    "change.field.chain.origin": "Made by",
    "change.field.chain.system_digest": "Module's declaration",
    "change.field.chain.manager_level": "Manager level",
    "change.field.chain.fallback_role": "Role when no manager can",
    "change.field.chain.mode": "Approvals needed",
    "change.field.chain.required": "Quorum",
    "change.field.chain.skip_conditions": "Skipped when",
    "change.field.chain.escalate_after_hours": "Escalates after (hours)",
    "change.field.chain.escalate_kind": "Escalates to",
    "change.field.chain.escalate_role": "Escalation role",
    "change.field.chain.escalate_users": "Escalation members",
    "change.field.chain.escalate_level": "Escalation manager level",
    "change.field.run.mode": "Approvals needed",
    "change.field.run.needed": "Approvals it needs",
    "change.field.run.approved_by": "Approved by",
    "change.field.run.escalate_at": "Escalates at",
    "change.field.run.escalated_at": "Escalated at",
    "change.field.run.escalated_to": "Escalated to",
    "nav.approvals.delegations": "Approval delegations",
    "nav.approvals.my_delegations": "My delegations",
    "nav.approvals.on_behalf": "Decided in my name",
    "perm.thing.approvals.delegations": "Approval delegations",
    "approvals.delegations.title": "Approval delegations",
    "approvals.delegations.lede": "Who decides in another member's name, and until when. A delegation counts while it runs; a delegate's own delegate decides nothing.",
    "approvals.delegations.empty": "No delegation yet.",
    "approvals.my_delegations.title": "My delegations",
    "approvals.my_delegations.lede": "Hand your approval decisions to a colleague while you are away. They decide in your name until the end you set, and you can end it sooner.",
    "approvals.my_delegations.empty": "You have not handed your decisions to anybody, and nobody has handed theirs to you.",
    "approvals.on_behalf.title": "Decided in my name",
    "approvals.on_behalf.lede": "Every decision a colleague took in your name while you had delegated to them.",
    "approvals.on_behalf.empty": "Nobody has decided anything in your name.",
    "approvals.col.delegation_state": "Status",
    "approvals.col.delegation_type": "Document type",
    "approvals.col.delegation_from": "Whose decisions",
    "approvals.col.delegation_to": "Decided by",
    "approvals.col.delegation_direction": "Direction",
    "approvals.col.delegation_source": "Made from",
    "approvals.col.from_at": "From",
    "approvals.col.to_at": "Until",
    "approvals.col.created_by": "Made by",
    "approvals.col.can_revoke": "Can be ended",
    "approvals.col.decision": "Decision",
    "approvals.col.decided_at": "Decided",
    "approvals.col.on_behalf_of": "On behalf of",
    "approvals.delegation_state.active": "In force",
    "approvals.delegation_state.scheduled": "Not started",
    "approvals.delegation_state.ended": "Ended",
    "approvals.delegation_state.revoked": "Ended early",
    "approvals.delegation_direction.given": "I gave",
    "approvals.delegation_direction.received": "Given to me",
    "approvals.delegation_source.manual": "By hand",
    "approvals.delegation_source.event": "Acting assignment",
    "approvals.delegation.every_type": "Every type",
    "approvals.decision_value.approve": "Approved",
    "approvals.decision_value.reject": "Rejected",
    "approvals.decision_value.return": "Returned",
    "approvals.field.delegation_from": "Whose decisions",
    "approvals.field.delegation_to": "Who decides instead",
    "approvals.field.delegation_type": "Document type",
    "approvals.field.delegation_type.help": "Left empty: every type.",
    "approvals.field.delegation_from_at": "From",
    "approvals.field.delegation_from_at.help": "Left empty: now.",
    "approvals.field.delegation_to_at": "To (included)",
    "approvals.field.delegation_reason": "Reason",
    "approvals.action.delegate": "New delegation",
    "approvals.action.revoke_delegation": "End now",
    "approvals.refusal.delegator_decided": "The members who delegated to you have approved this step, or an earlier one of this request, already.",
    "approvals.refusal.not_delegated": "You cannot decide this step in that member's name now.",
    "approvals.refusal.delegation_date": "This is not a date.",
    "approvals.refusal.delegation_filter": "This filter does not take that value.",
    "approvals.refusal.delegation_user": "Choose a member.",
    "approvals.refusal.delegation_self": "A member does not delegate to themselves.",
    "approvals.refusal.delegation_range": "A delegation ends after it starts.",
    "approvals.refusal.delegation_past": "This delegation would have ended already.",
    "approvals.refusal.delegation_too_long": "A delegation runs {max} days at most.",
    "approvals.refusal.delegation_member": "That person is not an active member of this workspace.",
    "approvals.refusal.no_delegation": "There is no such delegation.",
    "approvals.refusal.delegation_not_yours": "Only the member who gave a delegation by hand ends it here.",
    "approvals.refusal.delegation_ended": "This delegation has ended already.",
    "value.state.scheduled": "Not started",
    "value.state.revoked": "Ended early",
    "change.field.delegation.from_user": "Whose decisions",
    "change.field.delegation.to_user": "Decided by",
    "change.field.delegation.type_key": "Document type",
    "change.field.delegation.from_at": "From",
    "change.field.delegation.to_at": "Until",
    "change.field.delegation.reason": "Reason",
    "change.field.delegation.source": "Made from",
    "change.field.delegation.source_ref": "Assignment",
    "change.field.delegation.source_at": "Assignment changed at",
    "change.field.delegation.created_by": "Made by",
    "change.field.delegation.revoked_at": "Ended early at",
    "change.field.delegation.revoked_by": "Ended early by",
    "approvals.col.mode": "Approvals",
    "approvals.col.mode.required": "{required} of the deciders",
    "approvals.step_mode.any": "Any one",
    "approvals.step_mode.all": "Every one",
    "approvals.step_mode.quorum": "A number",
    "approvals.col.skip_count": "Skip conditions",
    "approvals.col.escalates": "Escalates",
    "approvals.col.escalates.template": "after {escalate_after_hours:hours} → {escalate_kind}",
    "approvals.escalate_kind.role": "a role",
    "approvals.escalate_kind.user": "named members",
    "approvals.escalate_kind.manager": "the requester's manager",
    "approvals.col.manager_level": "Manager level",
    "approvals.col.fallback_role": "Role when no manager can",
    "approvals.col.required": "Quorum",
    "approvals.col.escalate_kind": "Escalates to",
    "approvals.col.escalate_role": "Escalation role",
    "approvals.col.escalate_users": "Escalation members",
    "approvals.col.escalate_level": "Escalation manager level",
    "approvals.manager_level.1": "Direct manager",
    "approvals.manager_level.2": "Manager's manager",
    "approvals.manager_level.3": "3 levels up",
    "approvals.manager_level.4": "4 levels up",
    "approvals.manager_level.5": "5 levels up",
    "approvals.field.manager_level": "Manager level",
    "approvals.field.manager_level.help": "Counted from the person the document is about when it names one, otherwise from the requester; a level that is either of them passes up to the next. To see whom it reaches for a given requester, use «Try it» on this chain.",
    "approvals.field.fallback_role": "When there is no manager",
    "approvals.field.mode": "Approvals needed",
    "approvals.field.mode.help": "«Every one» is fixed when the step is reached: every decider then.",
    "approvals.field.required": "How many",
    "approvals.field.required.help": "Publishing refuses a number the step's deciders cannot meet.",
    "approvals.field.escalate_after_hours": "Escalate after (hours)",
    "approvals.field.escalate_after_hours.help": "Left empty: never. Those added decide beside the step's own deciders; nobody is removed.",
    "approvals.field.escalate_kind": "Escalate to",
    "approvals.field.escalate_role": "Escalate to the role",
    "approvals.field.escalate_users": "Escalate to the members",
    "approvals.field.escalate_level": "Escalate to the manager level",
    "approvals.step_section.step": "The step",
    "approvals.step_section.who": "Who decides",
    "approvals.step_section.count": "How many must approve",
    "approvals.step_section.escalate": "If it waits too long",
    "approvals.step_section.escalate.description": "When the step is skipped is set on the chain's «Steps skipped when» card, after the step is saved.",
    "approvals.step_conditions.title": "Steps skipped when",
    "approvals.step_conditions.note": "A step is skipped when all of its conditions hold, and kept on the request as «Skipped», with nobody deciding. A chain whose every step could be skipped is not published.",
    "approvals.step_conditions.empty": "No step is skipped: every step is decided on every document.",
    "approvals.action.add_step_condition": "Skip a step when…",
    "approvals.field.step": "Step",
    "approvals.col.approvals_of": "Approvals",
    "approvals.col.approvals_of.template": "{approved} of {needed} approved",
    "approvals.inbox.on_behalf": "On behalf of {on_behalf_of_name}",
    "approvals.col.approved": "Approved",
    "approvals.col.needed": "Approvals needed",
    "approvals.col.choose_on_behalf": "Asks in whose name",
    "approvals.col.decide_as": "Decided in the name of",
    "approvals.field.on_behalf_of": "Decide in the name of",
    "approvals.field.on_behalf_of.help": "Your own name comes first when you decide this step yourself; a delegator's decision counts as theirs.",
    "approvals.action.approve_as": "Approve…",
    "approvals.action.reject_as": "Reject or return…",
    "approvals.on_behalf.myself": "Myself",
    "hub.flag.escalated": "Escalated",
};
export const APPROVALS_AR = {
    "approvals.action.add_condition": "أضف شرطاً",
    "approvals.action.add_step": "أضف خطوة",
    "approvals.action.approve": "اعتمد",
    "approvals.action.archive": "أرشف",
    "approvals.action.create": "مسار جديد",
    "approvals.action.edit": "تعديل",
    "approvals.action.edit_step": "تعديل",
    "approvals.action.move_up": "قدّمها",
    "approvals.action.publish": "انشر",
    "approvals.action.reject": "ارفض أو أعد",
    "approvals.action.remove_condition": "احذف",
    "approvals.action.remove_step": "احذف",
    "approvals.action.resend": "أعد الإرسال",
    "approvals.action.revise": "نسخة مسودة",
    "approvals.action.simulate": "جرّبه في المحاكي",
    "approvals.action.withdraw": "اسحب الطلب",
    "approvals.amount_basis.gross": "الإجمالي قبل الضريبة",
    "approvals.amount_basis.net": "الصافي قبل الضريبة",
    "approvals.amount_basis.with_vat": "شاملاً الضريبة",
    "approvals.apply_state.applied": "نُفّذ",
    "approvals.apply_state.failed": "فشل التنفيذ",
    "approvals.apply_state.pending": "بانتظار التنفيذ",
    "approvals.approver_kind.role": "دور",
    "approvals.approver_kind.supplied": "أعضاء يسمّيهم المستند",
    "approvals.approver_kind.user": "أعضاء بأسمائهم",
    "approvals.chain.monogram": "مو",
    "approvals.chain.title": "مسار موافقة",
    "approvals.chain_conditions.empty": "بلا شروط: يطابق كل مستند من نوعه.",
    "approvals.chain_conditions.note": "كلها معاً (و). بلا شروط يطابق المسار كل مستند.",
    "approvals.chain_conditions.title": "الشروط",
    "approvals.chain_problems.empty": "لا شيء يمنع نشره.",
    "approvals.chain_problems.title": "قبل النشر",
    "approvals.chain_state.archived": "مؤرشف",
    "approvals.chain_state.draft": "مسودة",
    "approvals.chain_state.published": "منشور",
    "approvals.chain_steps.empty": "لا خطوات بعد: يُنشر المسار بخطوة واحدة على الأقل.",
    "approvals.chain_steps.note": "تحتاج الخطوة موافقة واحدة أو موافقة الجميع أو عدداً محدّداً. لا يقرر أحد طلبه ولا طلباً عنه.",
    "approvals.chain_steps.title": "الخطوات (متتالية)",
    "approvals.chains.empty": "لا مسار بعد. بلا مسار منشور لا يُرسل مستند من ذلك النوع للموافقة.",
    "approvals.chains.lede": "يمر كل مستند على أول مسار منشور تطابقه شروطه؛ لا مسار مطابق يعني رفض الإرسال، لا موافقة تلقائية.",
    "approvals.chains.title": "مسارات الموافقة",
    "approvals.col.amount": "المبلغ",
    "approvals.col.amount_basis": "المبلغ المقارَن",
    "approvals.col.apply_attempts": "مرات الإرسال",
    "approvals.col.apply_error": "سبب الوحدة",
    "approvals.col.apply_state": "التنفيذ",
    "approvals.col.approver": "المقرِّر",
    "approvals.col.approver_fact": "واقعة الأعضاء",
    "approvals.col.approver_kind": "من يقرر",
    "approvals.col.approver_role": "الدور",
    "approvals.col.approver_users": "الأعضاء",
    "approvals.col.at": "متى",
    "approvals.col.bulk_ok": "يُقرَّر جماعياً",
    "approvals.col.can_archive": "قابل للأرشفة",
    "approvals.col.can_edit": "قابل للتعديل",
    "approvals.col.can_move_up": "يمكن تقديمه",
    "approvals.col.can_publish": "قابل للنشر",
    "approvals.col.can_resend": "يمكن إعادة إرساله",
    "approvals.col.can_revise": "تُنشأ له نسخة",
    "approvals.col.can_withdraw": "يمكن سحبه",
    "approvals.col.chain": "المسار المختار",
    "approvals.col.chain_id": "المسار",
    "approvals.col.completed_at": "اكتملت الموافقة",
    "approvals.col.decider": "من قرّر",
    "approvals.col.deciders": "المقرِّرون",
    "approvals.col.document_revision": "نسخة المستند",
    "approvals.col.due_at": "القرار قبل",
    "approvals.col.fact_label": "الواقعة",
    "approvals.col.id": "المعرّف",
    "approvals.col.name_ar": "المسار",
    "approvals.col.name_en": "الاسم بالإنجليزية",
    "approvals.col.op": "المقارنة",
    "approvals.col.open_runs": "طلبات جارية",
    "approvals.col.outcome": "القرار",
    "approvals.col.path": "الموضع",
    "approvals.col.position": "الترتيب",
    "approvals.col.priority": "الأولوية",
    "approvals.col.problem": "ما يمنع النشر",
    "approvals.col.published_at": "نُشر",
    "approvals.col.reason": "السبب",
    "approvals.col.ref_label": "المستند",
    "approvals.col.revision": "النسخة",
    "approvals.col.route": "من يقرر كل خطوة",
    "approvals.col.rule": "القاعدة",
    "approvals.col.run_id": "المسار الجاري",
    "approvals.col.run_state": "الموافقة",
    "approvals.col.sla_hours": "المهلة (ساعات)",
    "approvals.col.state": "الحالة",
    "approvals.col.step": "الخطوة",
    "approvals.col.step_name": "اسم الخطوة",
    "approvals.col.step_of": "الخطوة من",
    "approvals.col.steps": "الخطوات",
    "approvals.col.type_key": "مفتاح النوع",
    "approvals.col.type_label": "نوع المستند",
    "approvals.col.value": "القيمة",
    "approvals.col.version": "إصدار القراءة",
    "approvals.field.approver_fact": "يسمّيهم المستند في",
    "approvals.field.approver_kind": "من يقرر",
    "approvals.field.approver_role": "الدور",
    "approvals.field.approver_users": "الأعضاء",
    "approvals.field.fact": "الواقعة",
    "approvals.field.name_ar": "الاسم بالعربية",
    "approvals.field.name_en": "الاسم بالإنجليزية",
    "approvals.field.op": "المقارنة",
    "approvals.field.outcome": "القرار",
    "approvals.field.priority": "الأولوية",
    "approvals.field.priority.help": "الأصغر يُقيَّم أولاً؛ مطلوبة للنشر.",
    "approvals.field.reason": "السبب",
    "approvals.field.reason.help": "يراه مقدّم الطلب ويُحفظ في السجل.",
    "approvals.field.requester_user": "مقدّم الطلب",
    "approvals.field.requester_user.help": "إن تُرك فارغاً: أنت.",
    "approvals.field.sla_hours": "المهلة (ساعات)",
    "approvals.field.sla_hours.help": "بعدها يُعلَن تأخّر الخطوة مرة كل يوم؛ ولا تُصعَّد إلا إذا ضُبط التصعيد أدناه، ولا يُوافَق على شيء تلقائياً.",
    "approvals.field.type_key": "نوع المستند",
    "approvals.field.value": "القيمة",
    "approvals.field.value.help": "المبلغ بالريال بخانتين عشريتين على الأكثر؛ والقيم المتعددة بفواصل.",
    "approvals.field.value_to": "إلى أقل من",
    "approvals.field.value_to.help": "للنطاق فقط: حدّه الأعلى، غير مشمول.",
    "approvals.hub.inbox.empty": "لا شيء ينتظر قرارك.",
    "approvals.hub.inbox.one": "مستند",
    "approvals.hub.inbox.summary": "{summary} · {step}",
    "approvals.hub.inbox.title": "المستندات",
    "approvals.not_applied.empty": "لا شيء فشل ولا شيء ينتظر التنفيذ.",
    "approvals.not_applied.lede": "موافقات لم تنفّذها وحدتها بعد أو فشل تنفيذها؛ الإصلاح في المستند، ثم أعد الإرسال.",
    "approvals.not_applied.title": "تمت الموافقة ولم يُنفّذ",
    "approvals.op.between": "من … إلى أقل من",
    "approvals.op.eq": "يساوي",
    "approvals.op.gt": "أكثر من",
    "approvals.op.gte": "لا يقل عن",
    "approvals.op.in": "أحد",
    "approvals.op.lt": "أقل من",
    "approvals.op.lte": "لا يزيد على",
    "approvals.op.ne": "لا يساوي",
    "approvals.op.not_in": "ليس أحد",
    "approvals.outcome.approve": "موافقة",
    "approvals.outcome.awaiting": "بانتظار القرار",
    "approvals.outcome.cancelled": "سُحب",
    "approvals.outcome.not_reached": "لم يصل إليها",
    "approvals.outcome.reject": "رفض",
    "approvals.outcome.sent_back": "إعادة للتعديل",
    "approvals.outcome_choice.reject": "رفض: ينتهي الطلب هنا",
    "approvals.outcome_choice.return": "إعادة للتعديل: يرسل مقدّم الطلب نسخة جديدة",
    "approvals.refusal.about_self": "لا يقرر أحد في طلب يخصه.",
    "approvals.refusal.limit": "اطلب من 1 إلى {max} بندًا.",
    "feed.approvals.assigned": "موافقات بانتظاري",
    "feed.approvals.assigned.status.waiting": "بانتظارك",
    "feed.approvals.assigned.status.overdue": "متأخرة",
    "feed.approvals.assigned.status.escalated": "مُصعّدة",
    "feed.approvals.assigned.status.cannot_decide": "ليس لك البتّ فيها الآن",
    "approvals.refusal.access_unavailable": "تعذّر الآن التحقق ممن يحق له رؤية هذا السجل. لم يُقرأ شيء؛ حاول مرة أخرى.",
    "approvals.refusal.archived": "هذا المسار مؤرشف أصلاً.",
    "approvals.refusal.bulk_not_allowed": "«{type}» يُقرَّر طلباً طلباً، لا جماعياً.",
    "approvals.refusal.bulk_over_limit": "ما فوق {max} يُقرَّر طلباً طلباً، لا جماعياً.",
    "approvals.refusal.bulk_return": "لا يُعاد طلب جماعياً؛ يُعاد طلباً طلباً.",
    "approvals.refusal.condition_fact": "يقرأ الشرط واقعة من وقائع نوع المستند.",
    "approvals.refusal.condition_op": "لا تُقارن هذه الواقعة بهذه الطريقة.",
    "approvals.refusal.condition_value": "هذه ليست قيمة تحملها هذه الواقعة.",
    "approvals.refusal.conditions_shape": "الشروط قائمة.",
    "approvals.refusal.decided_before": "قرّرت خطوة سابقة في هذا الطلب؛ يقرر هذه شخص آخر.",
    "approvals.refusal.draft_exists": "لهذا المسار مسودة قائمة.",
    "approvals.refusal.fact_choice": "اختر أحد خياراتها.",
    "approvals.refusal.fact_money": "مبلغ بخانتين عشريتين على الأكثر.",
    "approvals.refusal.fact_number": "رقم.",
    "approvals.refusal.fact_party": "طرف من سجل الأطراف.",
    "approvals.refusal.fact_unknown": "لا واقعة بهذا الاسم في نوع المستند.",
    "approvals.refusal.fact_users": "قائمة أعضاء.",
    "approvals.refusal.facts_shape": "الوقائع هي ما يعلنه نوع المستند.",
    "approvals.refusal.members_forbidden": "عرض الأعضاء يحتاج صلاحية عرض المستخدمين.",
    "approvals.refusal.members_unavailable": "تعذّر عرض الأعضاء الآن؛ حاول مرة أخرى.",
    "approvals.refusal.no_chain": "لم يُعدّ مسار موافقة لـ«{type}» بعد. تواصل مع مسؤول الإعداد.",
    "approvals.refusal.no_chain_found": "لا يوجد مسار موافقة كهذا.",
    "approvals.refusal.no_permission": "لا تملك الصلاحية التي يحتاجها هذا.",
    "approvals.refusal.no_run": "لا يوجد طلب موافقة كهذا.",
    "approvals.refusal.no_steps": "للمسار خطوة واحدة على الأقل.",
    "approvals.refusal.no_such_condition": "لا يوجد شرط كهذا.",
    "approvals.refusal.no_such_step": "لا توجد خطوة كهذه.",
    "approvals.refusal.not_draft": "المسار المنشور أو المؤرشف لا يُعدَّل؛ أنشئ منه نسخة مسودة.",
    "approvals.refusal.not_from": "انتهى هذا الطلب؛ لا شيء للقرار فيه.",
    "approvals.refusal.not_published": "لا تُنشأ نسخة مسودة إلا من مسار منشور.",
    "approvals.refusal.not_requester": "لا يسحب الطلب إلا مقدّمه.",
    "approvals.refusal.nothing_to_resend": "لا يُعاد إرسال إلا موافقة لم تنفّذها وحدتها.",
    "approvals.refusal.out_of_scope": "ليست هذه الخطوة مما تقرر فيه.",
    "approvals.refusal.own_request": "لا يقرر أحد طلبه.",
    "approvals.refusal.previous_open": "الطلب السابق لم ينتهِ بعد.",
    "approvals.refusal.previous_other": "الطلب السابق ليس لهذا المستند.",
    "approvals.refusal.priority_required": "للمسار المنشور أولوية.",
    "approvals.refusal.priority_shape": "الأولوية عدد صحيح من 1 إلى 999.",
    "approvals.refusal.priority_taken": "لمسار منشور آخر من النوع نفسه الأولوية {priority}.",
    "approvals.refusal.reason_long": "السبب بحدّ أقصى {max} حرفاً.",
    "approvals.refusal.reason_required": "اكتب السبب: يقرؤه مقدّم الطلب.",
    "approvals.refusal.ref_shape": "هذا ليس معرّف مستند.",
    "approvals.refusal.required": "هذا مطلوب.",
    "approvals.refusal.revision_older": "يُعاد إرسال المستند بنسخته نفسها أو بأحدث منها.",
    "approvals.refusal.revision_shape": "نسخة المستند عدد صحيح من 1.",
    "approvals.refusal.role_lacks_permission": "الخطوة {step}: الدور {role} لا يحمل صلاحية {permission}؛ أضفها للدور أو اختر دوراً آخر.",
    "approvals.refusal.role_no_holders": "الخطوة {step}: لا أحد يحمل الدور {role}.",
    "approvals.refusal.role_unknown": "الخطوة {step}: لا يوجد دور {role} هنا.",
    "approvals.refusal.roles_forbidden": "تحديث دليل الأدوار يحتاج صلاحية عرض المستخدمين.",
    "approvals.refusal.roles_unavailable": "تعذّر الآن معرفة صلاحيات الأدوار؛ حاول مرة أخرى.",
    "approvals.refusal.roles_unknown": "دليل الأدوار لم يُحدَّث بعد هنا؛ حدّثه أولاً.",
    "approvals.refusal.run_open": "هذا المستند ينتظر موافقة قائمة؛ اسحبها أولاً.",
    "approvals.refusal.stale": "تغيّر هذا منذ فتحته. أعد التحميل وحاول مرة أخرى.",
    "approvals.refusal.step_fact": "يُسمّى الأعضاء في واقعة أعضاء من وقائع النوع.",
    "approvals.refusal.step_kind": "يقرر الخطوة دور، أو أعضاء بأسمائهم، أو أعضاء يسمّيهم المستند.",
    "approvals.refusal.step_role": "اختر الدور الذي يقرر هذه الخطوة.",
    "approvals.refusal.step_sla": "المهلة ساعات صحيحة من 1 إلى 8760.",
    "approvals.refusal.step_users": "اختر من عضو واحد إلى {max} عضواً.",
    "approvals.refusal.step_without_deciders": "لا أحد غيرك يقرر الخطوة {step}؛ تواصل مع مسؤول الإعداد.",
    "approvals.refusal.steps_shape": "الخطوات قائمة.",
    "approvals.refusal.subject": "لا يوجد هذا السجل، أو ليس لك أن تطّلع عليه.",
    "approvals.refusal.subject_users": "قائمة أعضاء.",
    "approvals.refusal.too_long": "بحدّ أقصى {max} حرفاً.",
    "approvals.refusal.too_many_conditions": "بحدّ أقصى {max} شروط.",
    "approvals.refusal.too_many_steps": "بحدّ أقصى {max} خطوات.",
    "approvals.refusal.type_unknown": "لا تطبيق في مساحة العمل يعلن نوع المستند هذا.",
    "approvals.refusal.types_forbidden": "تعذّر عرض تطبيقات مساحة العمل لك.",
    "approvals.refusal.types_unavailable": "تعذّر الآن قراءة أنواع المستندات؛ لم يتغيّر شيء.",
    "approvals.refusal.unit_token": "وصل الطلب برمز وحدة تعذّر التحقق منه؛ لم يُقدَّم شيء.",
    "approvals.refusal.users_inactive": "الخطوة {step}: لا أحد من الأعضاء المسمَّين عضو نشط.",
    "approvals.refusal.version_shape": "الإصدار هو العدد الذي قُرئ به السجل.",
    "approvals.run_state.approved": "موافَق",
    "approvals.run_state.in_progress": "قيد الموافقة",
    "approvals.run_state.rejected": "مرفوض",
    "approvals.run_state.returned": "مُعاد",
    "approvals.run_state.withdrawn": "مسحوب",
    "approvals.simulate.no_chain": "لا مسار مطابق: سيُرفض الإرسال، ولا موافقة تلقائية.",
    "approvals.simulate.nobody": "الخطوة {step} لا أحد يقرر فيها.",
    "approvals.simulate.preview": "المسار الذي سيُختار",
    "approvals.simulate.roles_unknown": "دليل الأدوار لم يُحدَّث بعد: حدّثه أولاً.",
    "approvals.simulate.skipped": "«{chain}» (الأولوية {priority}) لم يطابق.",
    "approvals.subject_runs.empty": "لم يُرسل هذا المستند للموافقة.",
    "approvals.subject_runs.title": "مسار الموافقة",
    "change.field.chain.approver_fact": "يسمّيهم المستند في",
    "change.field.chain.approver_kind": "من يقرر",
    "change.field.chain.approver_label_ar": "المقرِّر بالعربية",
    "change.field.chain.approver_label_en": "المقرِّر بالإنجليزية",
    "change.field.chain.approver_role": "الدور",
    "change.field.chain.approver_users": "الأعضاء",
    "change.field.chain.archived_at": "أُرشف في",
    "change.field.chain.archived_by": "أرشفه",
    "change.field.chain.conditions": "الشروط",
    "change.field.chain.created_by": "أنشأه",
    "change.field.chain.lineage_id": "المسار",
    "change.field.chain.name_ar": "الاسم بالعربية",
    "change.field.chain.name_en": "الاسم بالإنجليزية",
    "change.field.chain.position": "الخطوة",
    "change.field.chain.priority": "الأولوية",
    "change.field.chain.published_at": "نُشر في",
    "change.field.chain.published_by": "نشره",
    "change.field.chain.revision": "النسخة",
    "change.field.chain.sla_hours": "المهلة (ساعات)",
    "change.field.chain.state": "الحالة",
    "change.field.chain.type_key": "نوع المستند",
    "change.field.run.activated_at": "بلغها في",
    "change.field.run.amount": "المبلغ",
    "change.field.run.applied_at": "نُفّذ في",
    "change.field.run.apply_attempts": "مرات الإرسال",
    "change.field.run.apply_error": "سبب الوحدة",
    "change.field.run.apply_error_key": "مفتاح السبب",
    "change.field.run.apply_sent_at": "آخر إرسال",
    "change.field.run.apply_state": "التنفيذ",
    "change.field.run.candidates": "من يحق له القرار",
    "change.field.run.chain_id": "المسار",
    "change.field.run.chain_revision": "نسخة المسار",
    "change.field.run.chain_snapshot": "المسار كما جُمّد",
    "change.field.run.completed_at": "انتهى في",
    "change.field.run.completed_by": "أنهاه",
    "change.field.run.correlation_id": "الربط",
    "change.field.run.current_seq": "الخطوة الحالية",
    "change.field.run.decided_at": "قُرّرت في",
    "change.field.run.decided_by": "قرّرها",
    "change.field.run.document_revision": "نسخة المستند",
    "change.field.run.due_at": "القرار قبل",
    "change.field.run.facts": "الوقائع",
    "change.field.run.id": "الخطوة",
    "change.field.run.module": "التطبيق",
    "change.field.run.name_ar": "اسم الخطوة بالعربية",
    "change.field.run.name_en": "اسم الخطوة بالإنجليزية",
    "change.field.run.previous_run_id": "الطلب السابق",
    "change.field.run.ref_entity": "نوع السجل",
    "change.field.run.ref_id": "السجل",
    "change.field.run.ref_label": "المستند",
    "change.field.run.requester_party": "الطالب",
    "change.field.run.requester_user": "مقدّم الطلب",
    "change.field.run.seq": "رقم الخطوة",
    "change.field.run.state": "الحالة",
    "change.field.run.steps_total": "الخطوات",
    "change.field.run.subject_party": "المعني",
    "change.field.run.subject_user_ids": "المعنيون",
    "change.field.run.submitted_at": "أُرسل في",
    "change.field.run.type_key": "نوع المستند",
    "change.field.run.type_snapshot": "النوع كما جُمّد",
    "entity.approvals.chain": "مسار موافقة",
    "entity.approvals.subject": "مسار الموافقة",
    "hub.flag.cannot_decide": "لم يعد لك أن تقرر فيه",
    "nav.approvals.chains": "مسارات الموافقة",
    "nav.approvals.not_applied": "تمت الموافقة ولم يُنفّذ",
    "nav.module.approvals": "الموافقات",
    "value.apply_state.failed": "فشل التنفيذ",
    "value.apply_state.pending": "بانتظار التنفيذ",
    "value.state.archived": "مؤرشف",
    "value.state.published": "منشور",
    "approvals.refusal.step_manager_level": "المدير من مستوى 1 إلى 5 صعوداً.",
    "approvals.refusal.step_fallback_role": "اختر الدور الذي يقرر حين لا يستطيع أي مدير.",
    "approvals.refusal.step_mode": "تحتاج الخطوة موافقة واحدة، أو موافقة كل من يقرر، أو عدداً منهم.",
    "approvals.refusal.step_required": "النصاب من 2 إلى 20 موافقة.",
    "approvals.refusal.quorum_unreachable": "الخطوة {step} تحتاج {required} موافقات، ولا يستطيع إعطاءها إلا {deciders}.",
    "approvals.refusal.step_escalate_hours": "مهلة التصعيد ساعات صحيحة من 1 إلى 8760.",
    "approvals.refusal.step_escalate_kind": "تُصعَّد الخطوة إلى دور أو أعضاء بأسمائهم أو مدير.",
    "approvals.refusal.step_escalate_role": "اختر الدور الذي تُصعَّد إليه الخطوة.",
    "approvals.refusal.step_escalate_users": "اختر من عضو إلى 20 عضواً يُصعَّد إليهم.",
    "approvals.refusal.every_step_skippable": "كل الخطوات قابلة للتخطي. اترك خطوة واحدة على الأقل لا تُتخطّى، حتى لا يُعتمد مستند دون أن يقرر فيه أحد.",
    "approvals.refusal.every_step_skipped": "كل خطوات المسار ستُتخطّى لهذا المستند، ولا يُعتمد مستند دون أن يقرر فيه أحد. راجع من يضبط الموافقات.",
    "approvals.refusal.system_chain": "هذا المسار يأتي مع وحدته وهو للقراءة فقط. انشر مساراً خاصاً بك لتوجيه هذه المستندات بطريقة أخرى.",
    "approvals.refusal.already_approved": "وافقت على هذه الخطوة من قبل؛ وهي بانتظار الآخرين.",
    "approvals.simulate.quorum_unreachable": "الخطوة {step} تحتاج {needed} موافقات وعدد من يقرر فيها أقل.",
    "approvals.simulate.step_skipped": "الخطوة {step} تُتخطّى لهذه البيانات.",
    "approvals.col.origin": "المصدر",
    "approvals.chain_origin.system": "وحدته (للقراءة فقط)",
    "approvals.chain_origin.workspace": "هذه المساحة",
    "approvals.approver_kind.manager": "مدير مقدّم الطلب",
    "change.field.chain.origin": "المصدر",
    "change.field.chain.system_digest": "تعريف الوحدة",
    "change.field.chain.manager_level": "مستوى المدير",
    "change.field.chain.fallback_role": "الدور حين لا يستطيع المدير",
    "change.field.chain.mode": "الموافقات المطلوبة",
    "change.field.chain.required": "النصاب",
    "change.field.chain.skip_conditions": "تُتخطّى حين",
    "change.field.chain.escalate_after_hours": "تُصعَّد بعد (ساعات)",
    "change.field.chain.escalate_kind": "تُصعَّد إلى",
    "change.field.chain.escalate_role": "دور التصعيد",
    "change.field.chain.escalate_users": "أعضاء التصعيد",
    "change.field.chain.escalate_level": "مستوى مدير التصعيد",
    "change.field.run.mode": "الموافقات المطلوبة",
    "change.field.run.needed": "عدد الموافقات اللازمة",
    "change.field.run.approved_by": "وافق عليها",
    "change.field.run.escalate_at": "تُصعَّد في",
    "change.field.run.escalated_at": "صُعّدت في",
    "change.field.run.escalated_to": "صُعّدت إلى",
    "nav.approvals.delegations": "تفويضات الموافقة",
    "nav.approvals.my_delegations": "تفويضاتي",
    "nav.approvals.on_behalf": "ما قُرّر باسمي",
    "perm.thing.approvals.delegations": "تفويضات الموافقة",
    "approvals.delegations.title": "تفويضات الموافقة",
    "approvals.delegations.lede": "من يقرّر باسم عضو آخر، وإلى متى. يسري التفويض طوال مدته، ولا يقرّر من فوّضه المفوَّض إليه شيئًا.",
    "approvals.delegations.empty": "لا تفويض بعد.",
    "approvals.my_delegations.title": "تفويضاتي",
    "approvals.my_delegations.lede": "سلّم قرارات الموافقة إلى زميل أثناء غيابك. يقرّر باسمك حتى النهاية التي تحددها، ولك إنهاؤه قبلها.",
    "approvals.my_delegations.empty": "لم تفوّض أحدًا، ولم يفوّضك أحد.",
    "approvals.on_behalf.title": "ما قُرّر باسمي",
    "approvals.on_behalf.lede": "كل قرار اتخذه زميل باسمك أثناء تفويضك له.",
    "approvals.on_behalf.empty": "لم يقرّر أحد شيئًا باسمك.",
    "approvals.col.delegation_state": "الحالة",
    "approvals.col.delegation_type": "نوع المستند",
    "approvals.col.delegation_from": "قرارات من",
    "approvals.col.delegation_to": "يقرّرها",
    "approvals.col.delegation_direction": "الاتجاه",
    "approvals.col.delegation_source": "المصدر",
    "approvals.col.from_at": "من",
    "approvals.col.to_at": "حتى",
    "approvals.col.created_by": "أنشأه",
    "approvals.col.can_revoke": "يمكن إنهاؤه",
    "approvals.col.decision": "القرار",
    "approvals.col.decided_at": "وقت القرار",
    "approvals.col.on_behalf_of": "نيابةً عن",
    "approvals.delegation_state.active": "سارٍ",
    "approvals.delegation_state.scheduled": "لم يبدأ",
    "approvals.delegation_state.ended": "انتهى",
    "approvals.delegation_state.revoked": "أُنهي مبكرًا",
    "approvals.delegation_direction.given": "منّي",
    "approvals.delegation_direction.received": "إليّ",
    "approvals.delegation_source.manual": "يدويًا",
    "approvals.delegation_source.event": "تكليف بالإنابة",
    "approvals.delegation.every_type": "كل الأنواع",
    "approvals.decision_value.approve": "موافقة",
    "approvals.decision_value.reject": "رفض",
    "approvals.decision_value.return": "إعادة",
    "approvals.field.delegation_from": "قرارات من",
    "approvals.field.delegation_to": "من يقرّر بدلًا منه",
    "approvals.field.delegation_type": "نوع المستند",
    "approvals.field.delegation_type.help": "إن تُرك فارغًا: كل الأنواع.",
    "approvals.field.delegation_from_at": "من",
    "approvals.field.delegation_from_at.help": "إن تُرك فارغًا: الآن.",
    "approvals.field.delegation_to_at": "إلى (يشمله)",
    "approvals.field.delegation_reason": "السبب",
    "approvals.action.delegate": "تفويض جديد",
    "approvals.action.revoke_delegation": "إنهاء الآن",
    "approvals.refusal.delegator_decided": "وافق من فوّضوك على هذه الخطوة أو على خطوة سابقة من هذا الطلب من قبل.",
    "approvals.refusal.not_delegated": "لا يمكنك أن تقرّر هذه الخطوة باسم هذا العضو الآن.",
    "approvals.refusal.delegation_date": "هذا ليس تاريخًا.",
    "approvals.refusal.delegation_filter": "لا يقبل هذا المرشّح تلك القيمة.",
    "approvals.refusal.delegation_user": "اختر عضوًا.",
    "approvals.refusal.delegation_self": "لا يفوّض العضو نفسه.",
    "approvals.refusal.delegation_range": "ينتهي التفويض بعد بدايته.",
    "approvals.refusal.delegation_past": "كان هذا التفويض سينتهي قبل الآن.",
    "approvals.refusal.delegation_too_long": "لا تزيد مدة التفويض على {max} يومًا.",
    "approvals.refusal.delegation_member": "هذا الشخص ليس عضوًا نشطًا في هذه المساحة.",
    "approvals.refusal.no_delegation": "لا يوجد تفويض كهذا.",
    "approvals.refusal.delegation_not_yours": "لا يُنهي التفويض هنا إلا العضو الذي منحه يدويًا.",
    "approvals.refusal.delegation_ended": "انتهى هذا التفويض من قبل.",
    "value.state.scheduled": "لم يبدأ",
    "value.state.revoked": "أُنهي مبكرًا",
    "change.field.delegation.from_user": "قرارات من",
    "change.field.delegation.to_user": "يقرّرها",
    "change.field.delegation.type_key": "نوع المستند",
    "change.field.delegation.from_at": "من",
    "change.field.delegation.to_at": "حتى",
    "change.field.delegation.reason": "السبب",
    "change.field.delegation.source": "المصدر",
    "change.field.delegation.source_ref": "التكليف",
    "change.field.delegation.source_at": "وقت تعديل التكليف",
    "change.field.delegation.created_by": "أنشأه",
    "change.field.delegation.revoked_at": "أُنهي مبكرًا في",
    "change.field.delegation.revoked_by": "أنهاه مبكرًا",
    "approvals.col.mode": "الموافقات",
    "approvals.col.mode.required": "{required} من المقرّرين",
    "approvals.step_mode.any": "أيٌّ منهم",
    "approvals.step_mode.all": "جميعهم",
    "approvals.step_mode.quorum": "عدد محدّد",
    "approvals.col.skip_count": "شروط التخطّي",
    "approvals.col.escalates": "التصعيد",
    "approvals.col.escalates.template": "بعد {escalate_after_hours:hours} ← {escalate_kind}",
    "approvals.escalate_kind.role": "دور",
    "approvals.escalate_kind.user": "أعضاء بأسمائهم",
    "approvals.escalate_kind.manager": "مدير مقدّم الطلب",
    "approvals.col.manager_level": "مستوى المدير",
    "approvals.col.fallback_role": "الدور إن لم يوجد مدير",
    "approvals.col.required": "العدد المطلوب",
    "approvals.col.escalate_kind": "التصعيد إلى",
    "approvals.col.escalate_role": "دور التصعيد",
    "approvals.col.escalate_users": "أعضاء التصعيد",
    "approvals.col.escalate_level": "مستوى مدير التصعيد",
    "approvals.manager_level.1": "المدير المباشر",
    "approvals.manager_level.2": "مدير المدير",
    "approvals.manager_level.3": "3 مستويات أعلى",
    "approvals.manager_level.4": "4 مستويات أعلى",
    "approvals.manager_level.5": "5 مستويات أعلى",
    "approvals.field.manager_level": "مستوى المدير",
    "approvals.field.manager_level.help": "يُحسب من الشخص الذي يخصّه المستند إن وُجد، وإلا من مقدّم الطلب؛ ومستوى يكون فيه أحدهما ينتقل إلى ما فوقه. لمعرفة من يصل إليه لمقدّم طلب معيّن استخدم «جرّبه» في هذا المسار.",
    "approvals.field.fallback_role": "إن لم يوجد مدير",
    "approvals.field.mode": "الموافقات المطلوبة",
    "approvals.field.mode.help": "«جميعهم» يُثبَّت عند الوصول إلى الخطوة: كل من يقرّر وقتها.",
    "approvals.field.required": "العدد",
    "approvals.field.required.help": "لا يُنشر المسار إن كان العدد أكبر ممّا يستطيعه مقرّرو الخطوة.",
    "approvals.field.escalate_after_hours": "التصعيد بعد (ساعات)",
    "approvals.field.escalate_after_hours.help": "فارغ: لا تصعيد. يُضاف من يُصعَّد إليه إلى مقرِّري الخطوة دون إزالة أحد.",
    "approvals.field.escalate_kind": "التصعيد إلى",
    "approvals.field.escalate_role": "يُصعَّد إلى الدور",
    "approvals.field.escalate_users": "يُصعَّد إلى الأعضاء",
    "approvals.field.escalate_level": "يُصعَّد إلى مستوى المدير",
    "approvals.step_section.step": "الخطوة",
    "approvals.step_section.who": "من يقرّر",
    "approvals.step_section.count": "كم موافقة تلزم",
    "approvals.step_section.escalate": "إذا طال الانتظار",
    "approvals.step_section.escalate.description": "متى تُتخطّى الخطوة يُضبط في بطاقة «تُتخطّى الخطوات إذا» في المسار بعد حفظ الخطوة.",
    "approvals.step_conditions.title": "تُتخطّى الخطوات إذا",
    "approvals.step_conditions.note": "تُتخطّى الخطوة إذا تحقّقت كل شروطها، وتبقى على الطلب بحالة «متخطّاة» دون مقرِّر. ولا يُنشر مسار يمكن تخطّي كل خطواته.",
    "approvals.step_conditions.empty": "لا تُتخطّى أي خطوة: كل خطوة يُقرَّر فيها على كل مستند.",
    "approvals.action.add_step_condition": "تخطَّ خطوة إذا…",
    "approvals.field.step": "الخطوة",
    "approvals.col.approvals_of": "الموافقات",
    "approvals.col.approvals_of.template": "{approved} من {needed} موافقات",
    "approvals.inbox.on_behalf": "نيابةً عن {on_behalf_of_name}",
    "approvals.col.approved": "الموافقات الحاصلة",
    "approvals.col.needed": "الموافقات المطلوبة",
    "approvals.col.choose_on_behalf": "يُسأل باسم من",
    "approvals.col.decide_as": "القرار باسم",
    "approvals.field.on_behalf_of": "القرار باسم",
    "approvals.field.on_behalf_of.help": "اسمك أولاً إن كنت من مقرّري الخطوة؛ والقرار باسم من فوّضك يُحسب له.",
    "approvals.action.approve_as": "موافقة…",
    "approvals.action.reject_as": "رفض أو إعادة…",
    "approvals.on_behalf.myself": "باسمي",
    "hub.flag.escalated": "مُصعَّدة",
};
//# sourceMappingURL=i18n-approvals.js.map